import { RUN_VIEWS } from '@ops-desk/contracts';
import { z } from 'zod';

export type RunView = (typeof RUN_VIEWS)[number];

const text = (max: number) =>
  z
    .union([z.string(), z.number()])
    .transform((v) => String(v).trim())
    .pipe(z.string().min(1).max(max))
    .optional()
    .catch(undefined);

/** URL search params of the submissions list. Invalid values fall back to the defaults. */
export const runsSearchSchema = z.object({
  view: z.enum(RUN_VIEWS).optional().catch(undefined),
  source: z.enum(['scheduled', 'operator']).optional().catch(undefined),
  q: text(100),
  page: z.number().int().min(1).optional().catch(undefined),
  size: z
    .union([z.literal(10), z.literal(25)])
    .optional()
    .catch(undefined),
  /** Opens the "New submission" dialog. */
  new: z.literal(true).optional().catch(undefined),
});
export type RunsSearch = z.infer<typeof runsSearchSchema>;
